<template>
    <div class="w-full space-y-3">
        <Head title="Reports"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Month End Report</h1>
            <a :href="route('frontend.reports.month-end-report-export', {
                        _query: {
                            search: this.form.search,
                            starts_at: this.form.starts_at,
                            ends_at: this.form.ends_at,
                            trading_entity: this.form.trading_entity
                        }
                    })"
                    class="inline-flex items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase bg-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Download Report
            </a>
        </div>
        <div class="grid grid-cols-4 gap-2">
            <div class="" v-if="trading_details.length > 1">
                <label for="trading-entity" class="block text-sm font-medium text-gray-700">Trading Entity</label>
                <select id="trading-entity" v-model="form.trading_entity"
                    class="mt-2 bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option value="" v-html="'All'"></option>
                    <option v-for="(trading_detail, index) in trading_details" :key="index" :value="trading_detail.id" :selected="form.trading_entity === trading_detail.id" v-html="trading_detail.trading_name"></option>
                </select>
            </div>
            <div class="">
                <label for="start-date" class="block text-sm font-medium text-gray-700">Start Date <span v-if="formattedStartDate">({{ formattedStartDate }})</span></label>
                <input v-model="form.starts_at" name="start-date" type="date" class="mt-2 bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 datepicker-input" placeholder="Select start date">
            </div>
            <div class="">
                <label for="end-date" class="block text-sm font-medium text-gray-700">End Date <span v-if="formattedEndDate">({{ formattedEndDate }})</span></label>
                <input v-model="form.ends_at" name="end-date" type="date" class="mt-2 bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 datepicker-input" placeholder="Select end date">
            </div>
            <div class="">
                <search-filter :show-filter="false" v-model:value="form.search" class="w-full mt-7" name="search" @reset="reset"></search-filter>
            </div>
        </div>
    </div>
    <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6 mt-5">
        <div class="flex flex-col space-y-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Fixture Title
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Fixture Reference
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Fixture Date
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Fixture Status
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Trading Name
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Estimated Cost
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Cost
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Estimated Revenue
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Sale
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Markup
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Management Fees
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Commission
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Profit
                                    </th>

                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Revenue Invoice Total
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Revenue Invoice Total Paid
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Revenue Invoiced Gap
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Supplier Invoice Total
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Supplier Invoice Total Paid
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Supplier Invoiced Gap
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Expenses
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="fixtures.data.length > 0" v-for="(fixture, index) in fixtures.data" :key="index">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.fixture.show' , fixture.id)">
                                            {{ fixture.title }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.fixture.show' , fixture.id)">
                                            {{ fixture.reference }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.fixture.show' , fixture.id)">
                                            {{ moment(fixture.starts_at, 'YYYY-MM-DD').format('DD MMM YYYY') }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.fixture.show' , fixture.id)">
                                            {{ fixture.status }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.fixture.show' , fixture.id)">
                                            {{ fixture.trading_details?.display_name }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.estimated_cost, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.cost, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.estimated_price, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.sale, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.markup, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.management_fee, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.commission, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.profit, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.invoice_total, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.invoice_total_paid, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.invoiced_gap, fixture.currency?.code ?? 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.supplier_invoice_total, 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.supplier_invoice_total_paid, 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.supplier_invoiced_gap, 'gbp', true) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(fixture.expenses_total, 'gbp', true) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Pagination :links="fixtures.links"/>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import pickBy from "lodash/pickBy";
    import debounce from "lodash/debounce";
    import mapValues from "lodash/mapValues";
    import Pagination from "@/Components/Pagination";
    import {Link, Head, useForm} from "@inertiajs/vue3";
    import Authenticated from "@/Layouts/Authenticated";
    import SearchFilter from "@/Components/SearchFilter";

    export default {
        layout: Authenticated,
        components: {
            Head,
            Link,
            Pagination,
            SearchFilter
        },
        props: ['fixtures', 'search', 'starts_at', 'ends_at', 'trading_details'],
        data(props) {
            return {
                form: {
                    search: this.search ?? null,
                    starts_at: this.starts_at,
                    ends_at: this.ends_at,
                    trading_entity: null
                }
            }
        },
        created() {
            this.moment = moment
        },
        methods: {
            reset() {
                this.form = mapValues(this.form, () => null)
            },
        },
        watch: {
            form: useForm({
                deep: true,
                handler: debounce(function () {
                    this.$inertia.get(route('frontend.reports.operational_month_end_report'), pickBy(this.form), {preserveState: true, preserveScroll: true})
                }, 500),
            }),
        }
    }
</script>
